/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforcoffee2Inputs */

const en_goodforcoffee2 = /** @type {(inputs: Goodforcoffee2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffee`)
};

const de_goodforcoffee2 = /** @type {(inputs: Goodforcoffee2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaffee`)
};

/**
* | output |
* | --- |
* | "Coffee" |
*
* @param {Goodforcoffee2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforcoffee2 = /** @type {((inputs?: Goodforcoffee2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforcoffee2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforcoffee2(inputs)
	return de_goodforcoffee2(inputs)
});
export { goodforcoffee2 as "goodForCoffee" }